import { Component, Input } from "@angular/core";

@Component({
  selector: "uni-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"],
})
export class CardComponent {
  @Input() public padding: string;

  @Input() public borderStyle?: "dashed" | "solid";

  @Input() public background: "white" | "gray" = "white";

  @Input() public shadow: "none" | "small" | "medium" | "large" = "medium";
}
